// eslint-disable-next-line no-restricted-imports
import dayjs from 'dayjs';
// eslint-disable-next-line no-restricted-imports
import 'dayjs/locale/de';
// eslint-disable-next-line no-restricted-imports
import duration, { CreateDurationType } from 'dayjs/plugin/duration';
// eslint-disable-next-line no-restricted-imports
import relativeTime from 'dayjs/plugin/relativeTime';
// eslint-disable-next-line no-restricted-imports
import advancedFormat from 'dayjs/plugin/advancedFormat';
// eslint-disable-next-line no-restricted-imports
import customParseFormat from 'dayjs/plugin/customParseFormat';

// eslint-disable-next-line no-restricted-imports
export { Duration } from 'dayjs/plugin/duration';

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

export type DateType = dayjs.Dayjs;
export type AnyInputDate = dayjs.ConfigType;

export class DateHelper {
  static duration: CreateDurationType = dayjs.duration;

  /**
   * Creates a new instance based on the given date or 'now' if no date is given
   *
   * @param date either string, Date or number. Number is interpreted as milliseconds since the epoch
   *             For normal unix epoch times just multiply the input value by 1000.
   * @param format specifies how the date is interpreted when date is given as string
   */
  static new(date?: AnyInputDate, format?: dayjs.OptionType): DateType {
    return dayjs(date, format);
  }

  static setLocale(lang: string) {
    dayjs.locale(lang);
  }
}
